"use client";

import { Layout} from 'antd';
import {Sidebar} from "@/theme/mainLayout/sidebar/sidebar";
import {myLinks} from "@/lib/routes/myLinks";
import {Loader} from "@/theme/ui";
import {useEffect, useState} from "react";
import {signOut, useSession} from "next-auth/react";
import {api} from "@/lib/api/api";

export const MainLayoutPage = ({children}) => {
    const {status, data} = useSession()
    const [isSetToken, setIsSetToken] = useState(false)

    useEffect(()=>{
        if (status === 'unauthenticated'){
            signOut({callbackUrl: myLinks.getUlr('sign-in')})
        }
        if (status === 'authenticated'){
            api.setToken(data.user.accessToken)
            setIsSetToken(true)
        }
    }, [status])

    return (
        <Layout
            style={{
                minHeight: '100vh',
                position: 'relative'
            }}
        >
            {(isSetToken) && (
                <>
                    <Sidebar />
                    <Layout>
                        <Layout.Content>
                            <div style={{
                                position: 'relative',
                                height: '100vh'
                            }}>
                                {children}
                            </div>
                        </Layout.Content>
                    </Layout>
                </>
            )}

        </Layout>
    );
}